import { createAsyncThunk } from '@reduxjs/toolkit';
import factoryOptionsApi from '../../../api/factoryOptionsApi';
import {
  createPaymentCodeCigarMapping,
  exportInitialPaymentCodeCigarMapping,
  getPaymentCodeCigarMapping,
  importPaymentCodeCigarMapping,
  removePaymentCodeCigarMapping,
  togglePaymentCodeCigarsMappingInactive,
  updatePaymentCodeCigarMapping,
  type ApiResponse,
  type PaymentCodeCigarMappingData,
} from '../../../api/paymentCodeCigarMappingApi';
import { download } from '../../../utils/files';

// -----------------------------------------------------------------------------

const REDUCER_NAME = 'paymentCodeCigarsMapping';

export const CreatePaymentCodeCigarsMapping = createAsyncThunk<
  { data: any; factory: string; status: string },
  PaymentCodeCigarMappingData
>(`${REDUCER_NAME}/createPaymentCodeCigarsMapping`, async (data, thunkAPI) => {
  const res = (await createPaymentCodeCigarMapping(data)) as ApiResponse;

  if (res.status === 200) {
    return { ...res.data, factory: data.factory, status: 'success' };
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetPaymentCodeCigarsMapping = createAsyncThunk(
  `${REDUCER_NAME}/getPaymentCodeCigarsMapping`,
  async (___, thunkAPI) => {
    const res = await getPaymentCodeCigarMapping();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue(null);
  }
);

export const ImportPaymentCodeCigarsMapping = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/importPaymentCodeCigarsMapping`,
  async (data, thunkAPI) => {
    const res = await importPaymentCodeCigarMapping(data);

    if (res.status === 200) {
      thunkAPI.dispatch(GetPaymentCodeCigarsMapping());
    }
  }
);

export const UpdatePaymentCodeCigarsMapping = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updatePaymentCodeCigarsMapping`,
  async ({ data }, thunkAPI) => {
    const res = await updatePaymentCodeCigarMapping(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetPaymentCodeCigarMappingOptions = createAsyncThunk(
  `${REDUCER_NAME}/getPaymentCodeCigarMappingOptions`,
  async (__, thunkAPI) => {
    const cigarTiersRes = await factoryOptionsApi.getByName('cigarTiers');

    if (cigarTiersRes.status === 200) {
      return {
        cigarTiersRes: cigarTiersRes.data,
      };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const RemovePaymentCodeCigarMapping = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/removePaymentCodeCigarMapping`,
  async (id, thunkAPI) => {
    const res = await removePaymentCodeCigarMapping(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ExportInitialPaymentCodeCigarMapping = createAsyncThunk(
  `${REDUCER_NAME}/exportInitialPaymentCodeCigarMapping`,
  async (__, thunkAPI) => {
    const res = await exportInitialPaymentCodeCigarMapping();

    if (res.status === 200) {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const fileName = res.headers['x-suggested-filename'];
      download(url, fileName);
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const TogglePaymentCodeCigarMappingInactive = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/togglePaymentCodeCigarsMappingInactive`,
  async (id, thunkAPI) => {
    const res = await togglePaymentCodeCigarsMappingInactive(id);
    if (res.status === 200) {
      return { inactive: res.data?.data, id };
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);
